import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { BASE_URL } from "../data/baseURL";

const SubscribeContact = () => {
  const { register, handleSubmit } = useForm();
  const [userInfo, setUserInfo] = useState({
    ip: "",
    country: "",
    countryCode: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    window
      .fetch("https://geolocation-db.com/json/")
      .then((res) => res.json())
      .then((data) => {
        setUserInfo({
          ip: data.IPv4,
          country: data.country_name,
          countryCode: data.country_code,
          latitude: data.latitude,
          longitude: data.longitude,
        });
      });
  }, []);

  const handleSubscribe = (data, e) => {
    const newsLetterInfo = {
      ...userInfo,
      email: data.email,
    };

    fetch(`${BASE_URL}/news-letter`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(newsLetterInfo),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          e.target.reset();
          swal("Thank You!", "For Subscribing!", "success");
        }
      });
  };
  return (
    <section className="row">
      <div className="col-12 col-md-12 col-lg-6 d-flex align-items-center justify-content-center digital-marketing-card-height bg-bright-gray">
        <div className="text-center">
          <h4 className="fs-28">Ready to get started?</h4>
          <h2 className="fs-28 gilroy-bold pb-5">CREATE A STRATEGY WITH MWI</h2>
          <Link
            to="/contact-us"
            className="text-decoration-none fs-18 text-dark text-uppercase d-inline-block mx-4 px-5 py-3 border-yellow gilroy-bold dm-contact-btn"
          >
            Contact Us
          </Link>
        </div>
      </div>
      <div className="col-12 col-md-12 col-lg-6 bg-ghost-white d-flex align-items-center justify-content-center digital-marketing-card-height">
        <div className="text-center">
          <h3 className="fs-28">Become a marketing expert</h3>
          <h2 className="fs-28 gilroy-bold pb-5 text-uppercase">
            READ OUR NEWSLETTER
          </h2>
          <form
            className="row align-items-center"
            onSubmit={handleSubmit(handleSubscribe)}
          >
            <div className="col-7 col-md-9 col-xl-10">
              <input
                type="email"
                required
                placeholder="Enter email"
                className="px-4 py-3 rounded border border-dark d-inline-block me-3 form-control fs-16"
              />
            </div>
            <div className="col-2 col-md-2 col-xl-2">
              <input
                type="submit"
                className="border-1 fs-18 text-dark text-uppercase px-5 py-3 border-yellow gilroy-bold dm-contact-btn"
              />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SubscribeContact;
